export default function getCurrencyFormat(value, currency) {
  const currencyToLocaleMapper = {
    INR: 'en-IN',
    SAR: 'en-SA',
    EUR: 'de-DE',
    USD: 'en-US',
  };
  return value && (Intl.NumberFormat(currencyToLocaleMapper[currency]).format(value));
}
